/**
 * Бренд Telegram-мини-аппа.
 *
 * Ребрендинг в KredaFi делался для сайта webtransfer.app и для нового
 * приложения на kredafi.webtransfer.app. Мини-апп в этот ребрендинг не
 * входил: внутри Telegram остаётся прежний бренд Webtransfer — логотип в
 * шапке, значок токена WEB и тексты такие же, как были до 07.09.2026.
 *
 * Правило: любой брендовый ассет или текст, который поменяли ради KredaFi,
 * в мини-аппе показываем в старом виде через этот модуль. Ветка KredaFi
 * (`isKredafiShell` в utils/brand.ts) сюда не заглядывает.
 */

import { isTelegramMiniApp } from "./platform";

/** Внутри Telegram показываем прежний бренд Webtransfer. */
export const isLegacyWebtransferBrand: boolean = isTelegramMiniApp;

/** Значок токена WEB рядом с суммой (шапка, дашборд, аукцион, балансы). */
export const webTokenIcon: string = isLegacyWebtransferBrand
  ? "/assets/LogoW.png"
  : "/assets/kredafi_k_only.png";

/**
 * Имя бренда в базе знаний и её заголовках.
 *
 * Прежние статьи Webtransfer (data/knowledgeBaseLegacy.ts) остались только в
 * мини-аппе; веб и приложение KredaFi читают переписанную базу.
 */
export const knowledgeBrandName: string = isLegacyWebtransferBrand
  ? "Webtransfer"
  : "KredaFi";
